import React from "react";
import { Button, ReferenceInput, SelectInput, TextInput, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";
import EditIcon from "@mui/icons-material/Edit";

const StartMonthlyInternshipDialog = ({ studentEducationId, fetchMonthlyInternship, isMonthlyInternshipStarted }) => {
  const notify = useNotify();

  const handleSubmit = async data => {
    const payload = {
      startDate: data.startDate,
      locationType: data.locationType,
      locationName: data.locationName,
      locationAddress: data.locationAddress,
      supervisor: data.supervisor,
    };

    await dataProvider.customRequest(
      graduationRequests.startStudentMonthlyInternship(studentEducationId),
      payload,
      "PUT",
    );
    notify("Успешно стартирахте месечен стаж", { type: "success" });
    fetchMonthlyInternship();
  };

  return (
    <FormModal
      titleContent={!isMonthlyInternshipStarted ? "Стартиране на месечен стаж" : "Редакция на месечен стаж"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label={!isMonthlyInternshipStarted ? "Стартиране на месечен стаж" : "Редакция на месечен стаж"}
          variant="contained"
          startIcon={!isMonthlyInternshipStarted ? <PlayArrowIcon /> : <EditIcon />}
        />
      }
    >
      <CustomDateInput
        source="startDate"
        noTime
        label="Започва на"
      />
      <ReferenceInput
        source="locationType"
        reference={graduationRequests.getStudentMonthlyInternshipLocationTypesSelect()}
      >
        <SelectInput
          optionText="nameBg"
          label="Тип локация"
        />
      </ReferenceInput>

      <TextInput
        source="locationName"
        label="Име на локация"
      />
      <TextInput
        source="locationAddress"
        label="Адрес на локация"
      />
      <TextInput
        source="supervisor"
        label="Ръководител"
      />
    </FormModal>
  );
};

export default StartMonthlyInternshipDialog;
